import React from 'react'
import { Toolbar } from '@mui/material'


function Animal() {
  return (
      <>
      
      <h1 className='animalHeader'>Alleviate Your Stress with Cute Animals</h1>
    <div className='vidBorder'>
      <iframe 
      width="560" height="315" 
      src="https://www.youtube.com/embed/ZuRLOlB4N8U" 
      title="YouTube video player" 
      frameborder="0" 
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
      allowfullscreen>

      </iframe>
    </div>
    </>
  )
}

export default Animal